import { recursoService } from '@/services/recursoService';

const state = {
  recursos: []
}

const getters = {
  recursos: state => state.recursos,
}

const actions = {
  async fetchRecursos({ commit }, { page, limit, status, query }) {
    commit('SET_LOADING', true);
    try {
      const response = await recursoService.getAll(page, limit, status, query);
      commit('SET_RECURSOS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_RECURSOS', []);
      commit('SET_LOADING', false);
    }
  },
  async addRecurso({ commit }, recurso) {
    commit('SET_LOADING', true);
    try {
      const response = await recursoService.create(recurso);
      commit('SET_RECURSO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async updateRecurso({ commit }, updRecurso) {
    commit('SET_LOADING', true);
    try {
      const response = await recursoService.update(updRecurso);
      commit('UPDATE_RECURSO', response.data.data);
      commit('SET_LOADING', false);
      return true;
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
      return false;
    }
  },
  async deleteRecurso({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await recursoService.destroy(id);
      commit('DELETE_RECURSO', id);
      commit('SET_LOADING', false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response.data.error;
      commit('SHOW_SNACKBAR', { text: errorMessage, status: 'error' });
      commit('SET_LOADING', false);
    }
  },
}

const mutations = {
  SET_RECURSOS: (state, recursos) => state.recursos = recursos,
  SET_RECURSO: (state, recurso) => state.recursos.push(recurso),
  UPDATE_RECURSO: (state, updRecurso) => {
    const index = state.recursos.findIndex(recurso => recurso._id === updRecurso._id)
    if (index !== -1) state.recursos.splice(index, 1, updRecurso);
  },
  DELETE_RECURSO: (state, id) => state.recursos = state.recursos.filter(recurso => recurso._id !== id)
}

export default {
  state,
  getters,
  actions,
  mutations
}